import React, { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import noneImage from '../assets/none-png-2.png'

const Container = styled.div`
    font-size:12px;
    a{
        color:inherit;
        text-decoration:none;
        font-size:inherit;
        font:inherit
    }
`

const Image = styled.div`
    width:${props => props.modal ? '40%' : '200px'};
    height:${props => props.modal ? '80%' : '400px'};
    position:${props => props.modal ? 'fixed' : 'unset'};
    top:${props => props.modal ? '50%' : 'unset'};
    left:${props => props.modal ? '50%' : 'unset'};
    transform:${props => props.modal ? 'translate(-50%,-50%)' : 'unset'};
    margin:${props => props.modal ? 'auto' : '0 10px 0 0'};
    background-size: cover;
    background-position: center center;
    border-radius: 4px;
    background-image:url(${props => props.bgUrl});
    @media screen and (max-width:768px){
        width:${props => props.modal ? '100%' : '100px'};
        height:${props => props.modal ? '100%' : '150px'};
        margin-right:10px;
        border-radius:2px;
    }
`

const ImageContainer = styled.div`
    cursor:pointer;
    width:${props => props.modal ? '100%' : 'unset'};
    height:${props => props.modal ? '100%' : 'unset'};
    position:${props => props.modal ? 'fixed' : 'unset'};
    top:${props => props.modal ? '50%' : 'unset'};
    left:${props => props.modal ? '50%' : 'unset'};
    transform:${props => props.modal ? 'translate(-50%,-50%)' : 'unset'};
    margin:${props => props.modal ? 'auto' : '0 10px 0 0'};
    background:${props => props.modal ? 'rgba(0,0,0,0.7)' : 'unset'};
`

const CastProfileImages = ({ imgUrl }) => {
    const [modal, setModal] = useState(false)
    const handleClick = (e) => {
        e.preventDefault()
        setModal(prev => !prev)
    }
    return (
        <Container>
            <ImageContainer onClick={handleClick} modal={modal}>
                <Image modal={modal} bgUrl={imgUrl && imgUrl ? `https://image.tmdb.org/t/p/original${imgUrl}` : noneImage} />
            </ImageContainer>
        </Container>)
}

CastProfileImages.propTypes = {
    id: PropTypes.number.isRequired,
    imgUrl: PropTypes.string,
    title: PropTypes.string.isRequired,
    rating: PropTypes.number,
    year: PropTypes.string,
    isMovie: PropTypes.bool
}

export default CastProfileImages